export interface ApplicationSubmittedDialogData {
}
export interface ApplicationSubmittedDialogResult {
}
